"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJavaRuntimeReleaseContent = exports.getJavaRuntimeReleaseAction = void 0;
const path_1 = require("path");
const extractor_1 = require("../../extractor");
const stream_utils_1 = require("../../stream-utils");
exports.getJavaRuntimeReleaseAction = {
    actionName: "java-runtime-release",
    filePathMatches: (filePath) => filePath === (0, path_1.normalize)("/opt/java/openjdk/release"),
    callback: stream_utils_1.streamToString,
};
function getJavaRuntimeReleaseContent(extractedLayers) {
    const content = (0, extractor_1.getContentAsString)(extractedLayers, exports.getJavaRuntimeReleaseAction);
    return content || "";
}
exports.getJavaRuntimeReleaseContent = getJavaRuntimeReleaseContent;
//# sourceMappingURL=static.js.map